<template>
  <formsTemplate>
    <v-form ref="form" v-model="valid" lazy-validation>
      <p class="font-weight-bold text-body-1 text-center mb-10">
        {{ $t("passwordView.btreeAccount") }}
      </p>
      <p class="font-weight-bold text-body-1">
        {{ $t("passwordView.password") }}
      </p>
      <v-text-field
        v-model="senha"
        solo
        hide-details="auto"
        autocomplete="off"
        :rules="[rules.required, rules.password]"
        flat
        @keydown.enter="logar"
        name="new-pass"
        :type="show ? 'text' : 'password'"
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
        <template slot="append">
          <a @click="show = !show">
            <v-icon>{{ show ? "$eye-off" : "$eye" }}</v-icon>
          </a>
        </template>
      </v-text-field>
      <p class="font-weight-bold text-body-1 mt-6">
        {{ $t("passwordView.repeatPassword") }}
      </p>
      <v-text-field
        v-model="confirme"
        solo
        hide-details="auto"
        autocomplete="off"
        :rules="[rules.required, rules.reppeat(senha, confirme)]"
        ref="confirme"
        flat
        @keydown.enter="logar"
        :type="show2 ? 'text' : 'password'"
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
        <template slot="append">
          <a @click="show2 = !show2">
            <v-icon>{{ show2 ? "$eye-off" : "$eye" }}</v-icon>
          </a>
        </template>
      </v-text-field>

      <div class="d-flex justify-space-between mt-10">
        <v-btn
          color="secondary"
          class="primary--text"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :to="{ name: 'login', query: $route.query }"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("passwordView.goBack") }}
          </p>
        </v-btn>
        <v-btn
          color="success"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :loading="loading"
          @click="logar"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("passwordView.send") }}
          </p>
        </v-btn>
      </div>
    </v-form>
  </formsTemplate>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { rules } from "@/mixins/rules";
import formsTemplate from "@/components/formsTemplate.vue";
export default {
  components: {
    formsTemplate,
  },
  mounted() {
    this.$refs.confirme.$el.addEventListener(
      "paste",
      function (E) {
        E.preventDefault();
        return false;
      },
      true
    );
  },
  data: () => ({
    show: false,
    show2: false,
    senha: "",
    confirme: "",

    rules,
    valid: false,
  }),
  computed: {
    ...mapState(useAuthStore, ["loading"]),
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["newPassword"]),

    async logar() {
      await this.$refs.form.validate();
      if (this.valid)
        this.newPassword({ password: this.senha, token: this.token });
    },
  },
};
</script>
<style scoped>
.m-auto {
  margin-left: auto;
  margin-right: auto;
}
::v-deep .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #252831;
}
</style>
